import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import moment from 'moment';
import { FileSaverService } from 'ngx-filesaver';

const EXCEL_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExportService {
  constructor(private fs: FileSaverService) {}

  exportExcel(req: any) {
    const data: any[] = [];
    const cols = [...req.displayedColumns];

    // Auto-generate labels from column names
    const labels = cols.map(col => this.formatLabel(col));

    // Remove 'actions' if present
    const index = cols.indexOf('actions');
    if (index !== -1) {
      cols.splice(index, 1);
      labels.splice(index, 1);
    }

    req.data.forEach((row: any, index: number) => {
      const obj: any = {};
      cols.forEach((col: string, i: number) => {
        const isMulti = req?.isDateMultiply ?? false;
        obj[labels[i]] =
          col === 'sno'
            ? index + 1
            : row[col]
            ? req?.dateField?.includes(col)
              ? moment(new Date(isMulti ? row[col] * 1000 : row[col])).format('DD-MM-YYYY hh:mm a')
              : row[col]
            : '--';
      });
      data.push(obj);
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const workbook: XLSX.WorkBook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
    const buffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    this.fs.save(blob, `${req.filename}_export_${Date.now()}${EXCEL_EXTENSION}`);
  }

  private formatLabel(key: string): string {
    return key
      .replace(/_/g, ' ')
      .replace(/\b\w/g, char => char.toUpperCase());
  }
}
